<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="d-flex justify-content-between">
        <div class="section-title">
          {{ "Ticket Invoices Report " }}
        </div>
        <div class="d-flex align-items-center">
         
          <div class="d-flex align-item-center">
                <input value="1" type="radio" v-model="lang_id">
                <span class="ml-1">English</span>
              </div>
              <div class="d-flex align-item-center ml-2">
              <input value="2" type="radio" v-model="lang_id">

              <span class="ml-1">العربية</span>
            </div>
        </div>
      </div>
      <small><em>{{ $t("* As Per Show Date") }}</em></small>

      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.selectedCinema && dropDown.selectedCinema.hasOwnProperty('cine_id')
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder=""
                @input="onSelectCinema($event)"
                :allowEmpty="true"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>


          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                            <Datepicker
                :monday-first="true"
                type="date"
                ref="programaticOpen"
                v-model="fromDate"
                v-validate="'required'"
                @selected="onChangeDate($event, 'from')"
              ></Datepicker>
              <label :class="fromDate ? 'active' : ''">
                {{ $t("fromdate") }}
              </label>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  {{ $t("todate") }}</label
                >
              </div>
            </div>    
          </div>

          <!-- Screen Filter -->
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
                <label :class="selectedScreen && selectedScreen.length > 0 ? 'shift-up' : 'font-weight-bold'">
                            {{ selectedScreen && selectedScreen.length > 0 ? $t("Screens") : $t("All Screens") }}
                            </label>
              <multiselect
                :options="screenList"
                v-model="selectedScreen"
                placeholder=""
                label="screen_name"
                :multiple="true"
                :close-on-select="false"
                track-by="screen_id"
              ></multiselect>
            </div>
          </div>
          <!-- Screen Filter -->

          <!-- Distributor Filter -->
          <div class="col-lg-6 col-xl-3 mb-4">
                     <div class="d-flex align-items-center">
                       <div class="dropdown-curve-container">
                         <label :class="selectedDistributor.length > 0 ? 'shift-up' : 'font-weight-bold'">
                          {{ selectedDistributor && selectedDistributor.length > 0 ? $t("Distributors") : $t("All Distributors") }}
                         </label>
         
                         <multiselect v-model="selectedDistributor" @input="onSelectHandler($event, 'distributor')"
                           @remove="onRemoveHandler($event, 'distributor')" placeholder=""
                           :options="getDistributorReportDropdownList" label="d_company_name" track-by="d_id" :multiple="true"
                           name="d_id" id="d_id" select-label="Select" deselect-label="Remove">
                         </multiselect>
                       </div>
                     </div>
                   </div>
        <!-- Distributor Filter -->

              <!-- show time filter -->
              <div class="position-relative col-lg-3 col-xl-2 mb-2">
                    <vue-timepicker manual-input
                     v-model="start_time"
                      id="starttime"
                      name="starttime"
                      :placeholder="$tc('starttime')"
                       format="HH:mm"
                       class="time_picker"
                       input-width="100%"
                       auto-scroll
                      lazy ></vue-timepicker>
                  </div>
       
          <div class="position-relative col-lg-3 col-xl-2 mb-2">
  <vue-timepicker
    manual-input
    v-model="end_time"
    id="endtime"
    name="endtime"
    :placeholder="$tc('endtime')"
    format="HH:mm"
    class="time_picker"
    input-width="100%"
    auto-scroll
    lazy
  />
</div>
        <!-- show time filter -->

        <!-- Movie Filter -->
           <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                   <div class="dropdown-curve-container">
                     <label :class="selectedMovieName && selectedMovieName.length > 0 ? 'shift-up' : 'font-weight-bold'">
                       {{ selectedMovieName && selectedMovieName.length > 0 ? $t("Movies") : $t("All Movies") }}
                     </label>
                     <multiselect v-model="selectedMovieName" :options="allMovieNames" track-by="movie_name"
                       label="movie_name" :disabled="isRoleID" :searchable="true" placeholder="Movies" :multiple="true">
                     </multiselect>
                   </div>
                 </div>
        <!-- Movie Filter -->

          <!-- Payment mode filter -->
          <div class="col-12 col-md-6 col-lg-3 col-xl-3  mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedPaymentSource && selectedPaymentSource.length > 0
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                > {{ selectedPaymentSource && selectedPaymentSource.length > 0 ? $t("Payment Mode") : $t("All Payment Mode") }}</label
              >
              <multiselect
                :options="paymentList"
                v-model="selectedPaymentSource"
                placeholder=""
                label="pm_payment_mode"
                :multiple="true"
                :close-on-select="false"
                track-by="pm_id"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
        <!-- Payment mode filter -->

          <div class="col-12 col-md-6 col-lg-6 col-xl-1 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onSubmit">
              {{ $t("fetch") }}
             
            </button>
          </div>

          <div   v-if="showDateData.length"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
            >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <img
            @click="getTicketInvoicesData('Y','N')"
                class="cursor-pointer"
                height="25"
                src="@/assets/img/icons/pdf-icon.svg"
                width="25"
              />

              <img  @click="getTicketInvoicesData('N','Y')" class="cursor-pointer ml-1"
              height="25" src="@/assets/img/icons/excel.svg" width="25" />
        </div>
        
   

        </div>
      </div>

      <div class="swc-report">
        <table
        class="swc-report-table"
        :class="lang_id==2?'swc-report-table reverse-order ':'swc-report-table order '"   
            border="1"
          > <thead class="bg-lightgrey">
              <tr :class="lang_id==2?' text-right':'text-center'">
                <th>{{ trans("showdate",lang_id) }}</th>
                <th>{{ trans("showTime",lang_id) }}</th>
                <th>{{ trans("screen",lang_id) }}</th>
                <th>{{ trans("movie",lang_id) }}</th>
                <th>{{ trans("ticketprice",lang_id) }}</th>
                <th>{{ trans("ticketnet",lang_id) }}</th>
                <th>{{ trans("totaltickets",lang_id) }}</th>
                <th>{{ trans("totalgross",lang_id) }}</th>
                <th>{{ trans("enttax",lang_id) }}</th>
                <th colspan="6">{{ trans("fees",lang_id) }}</th>
                <th>{{ trans("totaltax",lang_id) }}</th>
                <th>{{ trans("totalaftertax",lang_id) }}</th>
                <th>{{ trans("totalvat",lang_id) }}</th>
                <th>{{ trans("totalaftervat",lang_id) }}</th>
              </tr>
              <tr :class="lang_id==2?' text-right':'text-center'">
             <th></th>
             <th></th>
             <th></th>
             <th></th>
             <th></th>
             <th></th>
             <th></th>
             <th></th>
             <th></th>
             <th>{{ trans("socialsubside",lang_id) }}</th>
             <th>{{ trans("cinemasubside",lang_id) }}</th>
             <th>{{ trans("policesubside",lang_id) }}</th>
             <th>{{ trans("daransubside",lang_id) }}</th>
             <th>{{ trans("servicessubside",lang_id) }}</th>
             <th>{{ trans("sports",lang_id) }}</th>

             <th></th>
             <th></th>
             <th></th>
             <th></th>
            </tr>
            </thead>
            <tbody v-if="showDateData.length">
              <template v-for="showDate in showDateData">
                <template v-for="showTime in showDate.showDateData">
                  <template v-for="screen in showTime.showTimeData">
                    <template v-for="row in screen.screenData">
                      <tr >
                        <td class="text-left">{{ row.show_date }}</td>
                        <td class="text-left">{{ row.show_time }}</td>
                        <td class="text-left">{{ row.screen_name }}</td>
                        <td class="text-left">{{ lang_id==1?row.movie_title:row.movie_title_4?row.movie_title_2:row.movie_title }}</td>
                        <td class="text-right" >{{ currFormat(row.ticket_avg_price) }}</td>
                        <td class="text-right" >{{ currFormat(row.ticket_avg_net_price) }}</td>
                        <td class="text-right" >{{ row.tickets_no }}</td>
                        <td class="text-right" >{{ currFormat(row.tickets_gross) }}</td>
                        <td class="text-right" >{{ currFormat(row.entertainment_tax) }}</td>
                        <td class="text-right">
                        {{ parseFloat(row.fixed_fees.social).toFixed(2) || 0 }}
                      </td>
                      <td class="text-right">
                        {{ parseFloat(row.fixed_fees.cinema).toFixed(2) || 0 }}
                      </td>
                      <td class="text-right">
                        {{ parseFloat(row.fixed_fees.police).toFixed(2) || 0 }}
                      </td>
                      <td class="text-right">
                        {{ parseFloat(row.fixed_fees.daran).toFixed(2) || 0 }}
                      </td>
                      <td class="text-right">
                        {{
                          parseFloat(row.fixed_fees.services).toFixed(2) || 0
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          parseFloat(row.fixed_fees.sports).toFixed(2) || 0
                        }}
                      </td>
                      <td class="text-right">
                        {{ parseFloat(row.total_tax).toFixed(2) || 0 }}
                      </td>
                      <td class="text-right">
                        {{ parseFloat(row.total_after_tax).toFixed(2) || 0 }}
                      </td>
                      <td class="text-right">
                        {{ parseFloat(row.total_vat).toFixed(2) || 0 }}
                      </td>
                      <td class="text-right">
                        {{ parseFloat(row.total_after_vat).toFixed(2) || 0 }}
                      </td>

                      </tr>

                    </template>
                  </template>
                </template>
              </template>
              <tr  class="bg-lightgrey">
              <td colspan="6" :class="lang_id==1?'text-left':'text-right'">{{trans("grandtotal",lang_id)}}</td>
            
              <td class="text-right">{{ grandTotal.total_tickets_no ? grandTotal.total_tickets_no  : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_tickets_gross ? parseFloat(grandTotal.total_tickets_gross || 0).toFixed(2) : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_entertainment_tax ? parseFloat(grandTotal.total_entertainment_tax || 0).toFixed(2) : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_tickets_no ? parseFloat(grandTotal.social || 0).toFixed(2) : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_tickets_no ? parseFloat(grandTotal.cinema || 0).toFixed(2) : "0.00" }}</td>


              <td class="text-right">{{ grandTotal.total_tickets_no ? parseFloat(grandTotal.police || 0).toFixed(2) : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_tickets_no ? parseFloat(grandTotal.daran || 0).toFixed(2) : "0.00" }}</td>
              <td class="text-right">{{ grandTotal.total_tickets_no ? parseFloat(grandTotal.services || 0).toFixed(2) : "0.00" }}</td>
              <td class="text-right">{{ grandTotal.total_tickets_no ? parseFloat(grandTotal.sports || 0).toFixed(2) : "0.00" }}</td>
              <td class="text-right">{{ grandTotal.total_tax ? parseFloat(grandTotal.total_tax).toFixed(2) : "0.00" }}</td>
              <td class="text-right">{{ grandTotal.total_after_tax ? parseFloat(grandTotal.total_after_tax).toFixed(2) : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_vat ? parseFloat(grandTotal.total_vat).toFixed(2) : "0.00" }}</td>

              <td class="text-right">{{ grandTotal.total_after_vat ? parseFloat(grandTotal.total_after_vat).toFixed(2) : "0.00" }}</td>
            </tr>

            </tbody>
            <tbody v-if="!showDateData.length">
             <tr>
             <td colspan="12">No Record</td>
            </tr>
            </tbody>

          </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import NewReportService from "../../../services/NewReportService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
 import { authenticationService } from "@/services/AuthenticationService";
import * as XLSX from "xlsx";
import { mapState, mapActions, mapGetters } from "vuex";
 import ReportService from "@/services/ReportsService";


export default {
  components: {
    NoRecords,
    VueHtml2pdf,
    VueTimepicker
  },
  data() {
    return {
      selectedMovieName: [],
      allMovieNames: [],
      selectedDistributor:[],
       end_time: "",
      start_time: "",
      BASEURL,
      isRoleID: false,
      submitted: false,
      lang_id:"1",
     
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCineAddress: ""
      },
      screenList:[],
      showDateData: [],
      selectedScreen:[],

      fromDate: null,
      toDate: null,
      grandTotal: {},
      selectedPaymentSource:[],
      paymentList:[],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    this.fetchReportDistributorsList();
    this.getPaymentTypes();

  },
  watch: {
    fromDate() {
    this.getTicketInvoicesData("N", "N", "filter");
  },
  toDate() {
    this.getTicketInvoicesData("N", "N", "filter");
  },
  },
  mounted() {},
  computed: {
    
    distributorIds() {
          let text = ``;
          if (this.selectedDistributor.length > 0) {
            text = this.selectedDistributor.map(x => x.d_id).join(",");
          }
    
          return text;
        },
         ...mapGetters([
          "getDistributorReportDropdownList"
          //   "getDistributorReportMoviesList",
        ]),
    currentSelectedLanguage() {
      return this.$store.getters.GET_SELECTED_HEADER_LANGUAGE;
    },
    paymentModeId() {
      let text = ``;
      if (this.selectedPaymentSource.length > 0) {
        text = this.selectedPaymentSource.map(x => x.pm_id);
      }

      return text;
    }
  },
  methods: {
    moment,
    getPaymentTypes() {
          let body = {
            tableName: "ms_payment_modes",
            pm_is_active: "Y"
          };
          MasterService.GetActiveList(body).then(response => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.paymentList = data.Records;
               
              }
            } else this.$toasted.show(data.message || "Opps! Something went wrong");
          });
        },
    onSelectHandler(event,type){
            if (type =="distributor") {
            this.d_id = event.d_id;
            // this.selectedMovie = [];
            // this.MovieList = [];
             this.fetchDistributorMovies();
            // this.selectedDistributor = event;
          }
          },
           onRemoveHandler(event,type){
                  
              },
                 fetchDistributorMovies() {
                    if (!this.dropDown.selectedCinemaId) {
                      this.$toasted.show("Please Select Cinema");
                      this.selectedDistributor = [];
                      this.$forceUpdate();
                    } else {
                      this.MovieList = [];
                      let payload = {
                        fromDate: this.fromDate,
                        toDate: this.toDate,
                        cinema_id: this.dropDown.selectedCinemaId,
                          cinema_name: this.dropDown.selectedCinemaName,
                          cinema_address: this.dropDown.selectedCinemaAddres,
                        d_id: this.distributorIds,
                        d_company_name: this.selectedDistributor
                          .map(x => x.d_company_name)
                          .join(","),
                        country_id: authenticationService.get("BRGLOPCO"),
                        filter_with_key: "ss_actual_start_date"
                      };
                      ReportService.GetDistributorMovieFormat(payload)
                        .then(response => {
                          const { data } = response;
                          if (data && data.status && data.Records) {
                            this.MovieList = data.Records;
                          } else
                            this.$toasted.show(data.message || "Opps! Something went wrong");
                        })
                        .catch(error => {
                          this.$toasted.show(
                            "Catch Error on ReportStore fetchDistributorMovies",
                            error
                          );
                        });
                    }
                  },
    onChangeDate(e, type){
    if(type == 'from'){
      this.toDate = new Date(e);
      this.$forceUpdate();
    }
  },
    getCinemaList: function() {
      MasterService.GetCinemas()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function(event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCineAddress = event.cine_address;
      // console.log("Selected Cinema Name:", this.dropDown.selectedCinemaName);
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
        this.getCinemaScreens();
    },
    async getCinemaScreens(index) {
      try {
        const response = await MasterService.GetActiveList({
          tableName: "screens",
          screen_is_active: "Y",
          cinema_id: this.dropDown.selectedCinemaId,
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.screenList = data.Records;
        } else {
          console.log("show error:", data.message);
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    onSubmit() {
      this.getTicketInvoicesData("N","N");
    },
    async getTicketInvoicesData(isPdf = "N", isExcel = "N", type = "") {
  if (!this.dropDown.selectedCinemaId) {
    return this.$toasted.show("Select Cinema");
  }
  if (!this.fromDate) {
    return this.$toasted.show("Select From Date");
  }

  let loader;
  try {
    let screen_id = [];
    this.showDateData = [];

    if (this.selectedScreen.length) {
      screen_id = this.selectedScreen.map(screen => screen.screen_id);
    }

    loader = this.$loading.show();

    let payload = {
      cinema_id: this.dropDown.selectedCinemaId,
      cinema_name: this.dropDown.selectedCinemaName,
      fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
      toDate: moment(this.toDate).format("YYYY-MM-DD"),
      screen_id,
      cinema_address: this.dropDown.selectedCineAddress,
      lang_id: this.lang_id,
      start_time: this.start_time,
      end_time: this.end_time,
      d_id: this.distributorIds,
      d_company_name: this.selectedDistributor.map(x => x.d_company_name).join(","),
      payment_mode_id:this.paymentModeId,
      payment_name: this.selectedPaymentSource.map(x =>x.pm_payment_mode),
      screen_name: this.selectedScreen.map(x =>x.screen_name),
      isPdf,
      isExcel,
    };

    if (type === "filter") {
      payload["type"] = "filter";
    }

    if (this.selectedMovieName.length) {
      payload["selectedMovieName"] = this.selectedMovieName.map(item => item.movie_name);
    }

    const response = await NewReportService.getTicketInvoicesReport(payload);
    const { data } = response;

    if (!data.status) {
      return this.$toasted.show(data.message);
    }

    if (type == "filter") {
      this.allMovieNames = [...data.movieNamesData];
    }
    else {
    this.showDateData = data.Records;
    this.grandTotal = data.grandTotal;
    if (isPdf === "Y" && data.pdfPath) {
      window.open(data.pdfPath, "_blank");
    } 
    if (isExcel === "Y" && data.excelPath) {
      window.open(data.excelPath, "_blank");
    } 
      this.$toasted.show(data.message);
    }
  } catch (error) {
    console.error(error);
  } finally {
    if (loader) {
      loader.hide();
    }
  }
},
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      // "fetchDistributorsList",
      // "fetchDistributorsActiveMasterMovie",
      // FETCH LIST ONLY
      "fetchReportDistributorsList",
      "fetchDistributorReportList",
      "onDistributorReportDateHandler",
      "onDistributorReportDropdownHandler",
      "onDistributorReportFlagHandler",
      "onResetDistributorStoreState"
    ])
  }
};
</script>
<style scoped>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}

.swc-report-table th {
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.rtl-table-scroll {
  direction: rtl;
}

.color-blue {
  background-color: #cccccc;
}
.text-bold {
  font-weight: bold;
}
.rtl-table {
  display: flex;
  flex-direction: row-reverse; /* Reverse column order */
}

.rtl-table td {
  text-align: right; /* Align text properly for Arabic */
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: blue !important;
  border-color: blue !important;
}
.reverse-order{
  direction: rtl;
}
.order{
  direction: ltr
}

/* Change radio button color */
.j-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: red !important; /* Change the radio background color */
  border-color: red !important; /* Change the border color */
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/ticketInvoicesReport.vue